import React from "react";

export default function SpinnerLoader() {
  return (
    <div className="loadingSpinnerContainer">
      <div className="loadingSpinner" style={{borderColor:`${window.__E_TT_Client.primary} transparent ${window.__E_TT_Client.primary} transparent`}}></div>
    </div>
  );
}
